export const FEATURED_ITEMS_LOAD = 'FEATURED_ITEMS_LOAD';



// WEBPACK FOOTER //
// ./src/components/admin/featured-items/store/action-types.js